// Focusable, interactive elements that could possibly be in children
const focusableSelector = [
  'a[href]',
  'area[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  'iframe',
  'object',
  'embed',
  '[tabindex="0"]',
  '[contenteditable]',
  'audio[controls]',
  'video[controls]',
  'summary',
].join(',');

export const isTabbable = (element: HTMLElement) => {
  return element.tabIndex >= 0 || element?.dataset?.rovingTabindexItem;
};

/**
 * Checks if any of the ancestors of the element have a tabIndex greater than 0 or have the rovingTabindexItem data attribute on it.
 *
 * We are only going up 5 ancestors for performance reasons.
 */
export const hasTabbableAncestor = (
  element: HTMLElement,
  depth: number = 7
) => {
  let parent = element.parentElement;
  if (!parent) {
    return false;
  }

  let i = 0;
  while (i < depth && parent) {
    i++;
    if (isTabbable(parent)) {
      return true;
    }
    parent = parent.parentElement;
  }
  return false;
};

/**
 * Iterate through descendants to see if any are tabbable elements
 */
export const hasTabbableChildren = (element: HTMLElement) => {
  const descendants = element.querySelectorAll<HTMLElement>(focusableSelector);
  return Array.from(descendants).some(isTabbable);
};
